import React from 'react'
import { Link } from 'gatsby'
import { Layout } from '../../components/Layout'
import { SEO } from '../../components/SEO'
import { SocialLinks } from '../../components/SocialLinks'
import { useSpring, animated } from 'react-spring'
import classnames from 'classnames'
import * as classes from './contatti.module.scss'

const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2]
const trans = (x, y) =>
  `translate3d(${100 + x / 10}px,${-200 + y / 10}px,0) rotate(${x / 10}deg)`

const ContactPage = () => {
  const [props, set] = useSpring(() => ({
    xy: [0, 0],
    config: { mass: 30, tension: 550, friction: 540 },
  }))

  return (
    <Layout>
      <SEO title='Contatti' />
      <div className={classnames(['container', classes.contatti])}>
        <SocialLinks />
        <div className={classes.headline}>
          <h1>Vuoi raggiungere i tuoi obiettivi di business?</h1>
        </div>
        <div className={classes.shape}>
          <div
            onMouseMove={({ clientX: x, clientY: y }) =>
              set({ xy: calc(x, y) })
            }
          >
            <animated.div
              className={classes.decagon}
              style={{ transform: props.xy.interpolate(trans) }}
            />
          </div>
        </div>
        <div className={classes.content1}>
          Puoi scriverci a{' '}
          <a href='mailto:francesca.appi@btwofactory.com'>
            francesca.appi@btwofactory.com
          </a>
          ,<br />
          telefonare al numero{' '}
          <a href='tel:info@btwofactory.com'>328 4324930</a> oppure utilizzare
          il form qui sotto per contattarci.
          <br />
          Ti risponderemo al più presto.
        </div>
        <div className={classes.content2}>
          Prendiamoci un caffè insieme.
          <br />
          Ti aspettiamo nella nostra sede:
          <br />
          <strong>Via Giacomo Matteotti, 21 - 40128 Bologna</strong>
        </div>
        <div className={classes.content3}>
          <strong>Sei influencer?</strong>
          <br />
          Puoi scriverci a{' '}
          <a href='mailto:influencer@btwofactory.com'>
            influencer@btwofactory.com
          </a>{' '}
          per ricevere aggiornamenti e dettagli sulle collaborazioni con i
          nostri clienti.
        </div>
      </div>
    </Layout>
  )
}

export default ContactPage
